import React, { Component } from "react";
import { connect } from "react-redux";
import { Avatar, Button, Popconfirm, Popover } from "antd";
import { userSignOut } from "../../appRedux/actions/Auth";
import {
  fetchResource as getUserAttendance,
  createResource as saveAttendance
} from "../../appRedux/actions/AttendanceManpower";
import { Link } from "react-router-dom";
import moment from "moment";
import Attendance from "./attendance";
import AccessControl from "../AccessControl";
// import DesktopNotification from "./DesktopNotification";

const getInitials = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) {
    return '?';
  }
  const initials = parts.length === 1 ? parts[0][0] : `${parts[0][0]}${parts[parts.length - 1][0]}`;
  return initials.toUpperCase();
};

class UserInfo extends Component {

  // componentDidMount() {
  //   // this.props.getUserAttendance();
  // }

  // componentWillReceiveProps(nextProps) {
  //   // console.log(nextProps.attendance);
  // }

  render() {
    // const {roles} = this.props.authUser;
    // console.log(roles);
    const name = this.props.authUser && this.props.authUser.name;
    const userMenuOptions = (
      <ul className="gx-user-popover">
        <li className="gx-user-popover-greeting">Hello, <span style={{ color: '#038fde' }}>{name}</span></li>
        {/*{this.props && this.props.authUser && this.props.authUser.organisation ?*/}
        {/*(<li><Link to={"/setting"}>Setting</Link></li>) : null*/}
        {/*}*/}
        <li>
          <AccessControl
            resource={'ManpowerAttendance'}
            permissionNeeded={"c"}
            roles={this.props.authUser ? this.props.authUser.roles : []}
            render={props => {
              return (
                <Attendance fetchAttendance={this.props.getUserAttendance} attendance={this.props.attendance}
                  saveAttendance={this.props.saveAttendance} />
              );
            }}
          />
        </li>
        <li><Link to="/change-password">Change Password</Link></li>
        <li onClick={() => this.props.userSignOut()}>Logout</li>
        {/*<li><DesktopNotification/></li>*/}
      </ul>
    );

    return (
      <Popover overlayClassName="gx-popover-horizantal gx-user-popover-overlay" placement="bottomRight" content={userMenuOptions}
        trigger="click">
        <Avatar
          className="gx-avatar gx-pointer gx-avatar-initials"
          style={{ width: '35px', height: '35px', lineHeight: '35px', fontWeight: 600 }}
        >
          {getInitials(name)}
        </Avatar>
      </Popover>
    )
  }
}

const mapStateToProps = ({ auth, manpowerAttendance }) => {
  return {
    authUser: auth.authUser,
    attendance: manpowerAttendance.attendance,
  }
};

export default connect(mapStateToProps, { userSignOut, getUserAttendance, saveAttendance })(UserInfo);
